"use client"
import {
  Button
} from "./chunk-ZBAUJ4LY.mjs";

// src/components/file-button.ts
import { mergeStyle } from "@yamada-ui/core";
var FileButton = mergeStyle(Button)();

export {
  FileButton
};
//# sourceMappingURL=chunk-4TUOET7U.mjs.map